import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { StaffMetaData } from 'frontend/types/profile';

interface StaffMetaDataState {
  staffMetaData: StaffMetaData[];
}

const stateModule: Module<StaffMetaDataState, RootState> = {
  namespaced: true,
  state: {
    staffMetaData: [],
  },

  mutations: {
    setValue(state: StaffMetaDataState, value: StaffMetaData[]) {
      state.staffMetaData = value;
    },
  },
};

export default stateModule;
